import { lexonHttp as http } from '@/plugins/axios/lexonHttp'
import {
  BankdataTypeEnum,
  FacturaEUserMessages,
  IBankdraftForUpdate,
  IFacturaEForUpdate
} from '@/store/modules/facturaE/facturaETypes'
import { IFacturaERequestAccountModel } from '@/components/billing/FacturaEAccount/types/FacturaEAccountTypes'
import { IFacturaEValidatorError } from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'

export class FacturaEService {
  async generateDocument(document: {
    invoiceId: number,
    templateName: string,
    templateId: string,
    fileName: string
  }) {
    try {
      return await http.post(
        `/v2/customer-invoice/${ document.invoiceId }/factura-e/document`,
        JSON.stringify(document)
      )
    } catch (error) {
      return this.errorHandler(error)
    }
  }

  async validate(invoiceId: number) {
    try {
      return await http.get(`/v2/customer-invoice/${ invoiceId }/factura-e/validate`)
    } catch (error) {
      return this.errorHandler(error)
    }
  }

  async send(invoiceId: number) {
    try {
      return await http.post(`/v2/customer-invoice/${ invoiceId }/factura-e/send`)
    } catch (error) {
      return this.errorHandler(error)
    }
  }

  async professionals() {
    return await http.get(`/v2/customer-invoice/professionals`)
  }

  async bankdata(invoiceId: string, BankdataTypeEnum: BankdataTypeEnum) {
    return await http.get(`/v2/customer-invoice/${ invoiceId }/bankdata/${ BankdataTypeEnum }`)
  }

  async requestAccount(professional: IFacturaERequestAccountModel) {
    try {
      return await http.post(
        `/v2/factura-e/account/license`,
        JSON.stringify(professional)
      )
    } catch (error) {
      return this.errorHandler(error)
    }
  }

  async getFacturaE(invoiceId: string) {
    await http.get(`/v2/customer-invoice/${ invoiceId }/factura-e`)
  }

  async updateFacturaE(facturaE: IFacturaEForUpdate) {
    await http.put(
      `/v2/customer-invoice/${ facturaE.invoiceId }/factura-e`,
      JSON.stringify(facturaE)
    )
  }

  async updateBankdraft(facturaEBankdraft: IBankdraftForUpdate) {
    await http.put(
      `/v2/customer-invoice/${ facturaEBankdraft.invoiceId }/factura-e/bankdraft/${ facturaEBankdraft.bankdraftId }`,
      JSON.stringify(facturaEBankdraft)
    )
  }

  private errorHandler(error: any) {
    if (error.response && error.response.data) {
      const responseData = error.response.data
      if (responseData.exceptionDesc) {
        return { data: { error: this.parseExceptionDesc(responseData.exceptionDesc) } }
      }
      if (Array.isArray(responseData)) {
        const validatorErrors = responseData.map(error => {
          return {
            ...error,
            message: this.parseErrorMessage(error.message)
          }
        }) as IFacturaEValidatorError[]

        return {
          data: { validatorErrors }
        }
      }
    }

    return { data: { error: `no se puede procesar la petición` } }
  }

  private parseErrorMessage(message: string): string {
    return message.replace(/#([^:]+:[^#]+)#/g, (_match, p1) => {
      const parts = p1.split(':')
      const invoiceNumber = parts[0]
      const invoiceId = parts[1]
      return `<a href="/facturacion/facturas-clientes/${ invoiceId }" target="_blank" >${ invoiceNumber }</a>`
    })
  }

  private parseExceptionDesc(exceptionDesc: string): string {
    if (Object.prototype.hasOwnProperty.call(FacturaEUserMessages, exceptionDesc)) {
      return FacturaEUserMessages[exceptionDesc as keyof typeof FacturaEUserMessages]
    }

    return exceptionDesc
  }
}
